import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import SelectSeller from "../../SelectSeller/SelectSeller";
import Textarea from "../../Textarea-new/Textarea";
import SelectBuyer from "../../SelectBuyer/SelectBuyer";

const OwnershipInfo = ({isAgent, data, seller, handleChangeDropdown, handleSellerChangeDropdown, handleSellerChangeInput, edit, addNewItem, viewMode, deleted, sellerSelected, newSeller, newBuyer, isFinancing}) => {
    return (
        <div className="Ownership-info">
            {
                isFinancing &&
                <div className="Ownership-info_column">
                    <SelectBuyer
                        className="Ownership-info_column_item"
                        isFromProperty
                        value={data.BUYER_ID}
                        valueKey="BUYER_ID"
                        label="Buyer"
                        data={data}
                        handleParentChange={handleChangeDropdown}
                        withAddNew
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newBuyer={newBuyer}
                    />
                    <SelectSeller
                        isFromProperty
                        value={data.SELLER_ID}
                        valueKey="SELLER_ID"
                        label="Seller"
                        data={data}
                        handleParentChange={handleSellerChangeDropdown}
                        withAddNew
                        addNewItem={addNewItem}
                        viewMode={viewMode}
                        deleted={deleted}
                        newSeller={newSeller}
                    />
                </div>
            }
            {
                !isFinancing && edit && data.SELLER_ID && !sellerSelected &&
                <div className="Ownership-info_column">
                    <div className="Ownership-info_title">Seller</div>
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="FIRST_NAME"
                        label="First Name"
                        value={seller.FIRST_NAME}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="LAST_NAME"
                        label="Last Name"
                        value={seller.LAST_NAME}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="phone"
                        name="PHONE"
                        label="Phone"
                        value={seller.PHONE}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="email"
                        name="EMAIL"
                        label="Email"
                        value={seller.EMAIL}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Dropdown
                        className="Ownership-info_column_item"
                        data={seller}
                        isFromProperty
                        optionsType="profiles"
                        value={seller.PROFILE}
                        valueKey="PROFILE"
                        label="Profile"
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Textarea
                        className="Ownership-info_column_item"
                        disabled={isAgent}
                        label="Notes"
                        name="NOTES"
                        value={seller.NOTES}
                        maxWidth="100%"
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
            }
            {
                !isFinancing && edit && data.SELLER_ID && !sellerSelected &&
                <div className="Ownership-info_column">
                    <div className="Ownership-info_title">Seller Company</div>
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="COMPANY_NAME"
                        label="Company Name"
                        value={seller.COMPANY_NAME}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="COMPANY_ADDRESS"
                        label="Company Address"
                        value={seller.COMPANY_ADDRESS}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="COMPANY_CITY"
                        label="City"
                        value={seller.COMPANY_CITY}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Dropdown
                        className="Ownership-info_column_item"
                        data={seller}
                        isFromProperty
                        optionsType="states"
                        optionKey="abbr"
                        optionLabelKey="name"
                        value={seller.COMPANY_STATE}
                        valueKey="COMPANY_STATE"
                        label="State"
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <Input
                        className="Ownership-info_column_item"
                        valueType="text"
                        name="COMPANY_ZIP"
                        label="Zip"
                        value={seller.COMPANY_ZIP}
                        disabled={isAgent}
                        handleParentChange={handleSellerChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
            }
            {
                !isFinancing && (!edit || data.SELLER_ID === null || sellerSelected) &&
                <div className="Ownership-info_column">
                    <div className="Ownership-info_column_item">
                        <SelectSeller
                            isFromProperty
                            value={data.SELLER_ID}
                            valueKey="SELLER_ID"
                            label="Seller"
                            data={data}
                            handleParentChange={handleSellerChangeDropdown}
                            withAddNew
                            addNewItem={addNewItem}
                            viewMode={viewMode}
                            deleted={deleted}
                            newSeller={newSeller}
                        />
                    </div>
                </div>
            }
        </div>
    );
};

export default OwnershipInfo;
